//get请求{  url: "/login/login",method: "get", params,}params
//post (json)请求{  url: "/login/login",method: "post", data: params,} data: params
//post (form)请求{  url: "/login/login",method: "post",  params,data,}
import request from "@/plugins/axios";
// 先进管理列表/user/advanced/list
export function pluginsListApi(params) {
  return request({
    url: "/user/advanced/list",
    method: "get",
    params,
  });
}
// 修改用户信息 /user/updateInfo
export function updateUserInfor(params) {
  return request({
    url: "/user/updateInfo",
    method: "post",
    data: params,
  });
}
// 修改快捷回复 /fastReply/update
export function fastReplyUpdateApi(params) {
  return request({
    url: "/fastReply/update",
    method: "put",
    data: params,
  });
}
// 创建快捷回复 /fastReply/create
export function replyCreateApi(params) {
  return request({
    url: "/fastReply/create",
    method: "post",
    data: params,
  });
}
// 获取快捷回复列表 /fastReply/list
export function fastReplyListApi(params) {
  return request({
    url: "/fastReply/list",
    method: "get",
    params,
  });
}
// 修改回复内容 /reply/update
export function replyUpdateApi(params) {
  return request({
    url: "/reply/update",
    method: "put",
    data: params,
  });
}
// 删除回复 /reply/delete
export function replyDeleteApi(params) {
  return request({
    url: "/reply/delete",
    method: "DELETE",
    params,
  });
}
// 获取回复详情 /remark/info/{id}
export function remarkInfoApi(params) {
  return request({
    url: `/remark/info/${params.id}`,
    method: "get",
    params,
  });
}
// 回复 /reply
export function replyApi(params) {
  return request({
    url: "/reply",
    method: "post",
    data: params,
  });
}
// 发送评论或者留言  /remark/create
export function remarkCreateApi(params) {
  return request({
    url: "/remark/create",
    method: "post",
    data: params,
  });
}
// 编辑评论或者留言 /remark/update
export function remarkUpdateApi(params) {
  return request({
    url: "/remark/update",
    method: "put",
    data: params,
  });
}
// 获取留言或者评论列表 /remark/list
export function remarkListApi(params) {
  return request({
    url: "/remark/list",
    method: "get",
    params,
  });
}
// 模块详情 /module/info/{id}
export function moudleInfoApi(params) {
  return request({
    url: `/module/info/${params.id}`,
    method: "get",
    params,
  });
}
// 修改模块 /module/update
export function moudleUpdateApi(params) {
  return request({
    url: "/module/update",
    method: "put",
    data: params,
  });
}
// 获取所有模块 /module/list
export function moudleListApi(params) {
  return request({
    url: "/module/list",
    method: "get",
    params,
  });
}
// 创建模块 /module/create
export function addMoudleApi(params) {
  return request({
    url: "/module/create",
    method: "post",
    data: params,
  });
}

//用户登录
export function Login(params) {
  return request({
    url: "/login/login",
    method: "post",
    data: params,
  });
}
//wx登录
export function wxLogin(params) {
  return request({
    url: "/wechat/scan",
    method: "post",
    data: params,
  });
}
//wx解绑
export function wxunbind(params) {
  return request({
    url: "/wechat/unbind",
    method: "post",
    data: params,
  });
}
//所属检察院
export function getAllRegion(params) {
  return request({
    url: "/region/get-all-region",
    method: "post",
    data: params,
  });
}
//oss
export function uploadPictrue(params) {
  return request({
    url: "/oss/uploadPictrue",
    method: "post",
    params,
    data
  });
}

//新增用户-保存基本信息(草稿)
export function updateUserinfo(params) {
  return request({
    url: "/user/update-userinfo",
    method: "post",
    data: params,
  });
}
//账号管理列表
export function userlist(params) {
  return request({
    url: "/user/userlist",
    method: "post",
    data: params,
  });
}
//冻结解冻
export function updateStatus(params) {
  return request({
    url: "/user/update-status",
    method: "post",
    data: params,
  });
}
//所获荣誉里面数据
export function gethonorList(params) {
  return request({
    url: "/user/get-honor-list",
    method: "post",
    data: params,
  });
}
//所获荣誉里面数据
export function getUserinfo(params) {
  return request({
    url: "/user/get-userinfo",
    method: "post",
    data: params,
  });
}
//先进管理列表
export function userlistPost(params) {
  return request({
    url: "/user/user-list",
    method: "post",
    data: params,
  });
}
//提交审核(一系列操作)
export function checkUser(params) {
  return request({
    url: "/user/check-user",
    method: "post",
    data: params,
  });
}
//修改手机号
export function updatePhone(params) {
  return request({
    url: "/user/update",
    method: "post",
    data: params,
  });
}
//数据统计-总数
export function statiSticsTotal(params) {
  return request({
    url: "/user/statistics-total",
    method: "post",
    data: params,
  });
}
//管理员修改密码
export function updatePassword(params) {
  return request({
    url: "/user/update-password",
    method: "post",
    data: params,
  });
}
//获取区域列表
export function regionList(params) {
  return request({
    url: "/region/get-region",
    method: "post",
    data: params,
  });
}
